import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { BodyTemplateDirective } from './tablecustombody.template.directive';

@Directive({
  selector: 'table-body',
  standalone: false,
})
export class TableBodyDirective {
  @ContentChild(BodyTemplateDirective, { read: TemplateRef }) template: TemplateRef<any>;
}
